export const sliceName = 'specialitiesSearch'

export const allTagName = 'Все разделы рубрики'

export const specialitiesSearchLimit = 15
